const o=()=>window.self!==window.top;export{o as inIframe};
//# sourceMappingURL=inIframe.js.map
